import React, { Component } from "react";

import { Translate } from "react-redux-i18n";
import SalvadorCaetanoLogo from "../../../styles/images/SalvadorCaetanoLogo.svg";
import "../../../styles/components/legal/Legal.scss";
let counter;

class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    counter = 1;
  }

  renderListItems(key, children) {
    let childrenListItems = [];
    for (let i = 1; i <= children; i++) {
      if (key === "legalPP_scope_text") {
        // eslint-disable-next-line no-lone-blocks
        {
          if (i === 1) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_${i}`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_${i}_1`} />
                </span>
                <br></br>
              </>
            );
          } else if (i === 2) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_2`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_2_1`} />
                </span>
                <br></br>
                <span>
                  <div className="tab3">
                    {/* table header */}
                    <div className="tabRowTopLeftHeader">
                      <Translate value={`legalPP_scope_text_2_1_header`} />
                    </div>
                    <div className="tabRowTopRightHeader">
                      <Translate value={`legalPP_scope_text_2_2_header`} />
                    </div>
                    {/* first row */}
                    <div className="tabRowTopLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_1`}
                        />
                      </b>
                    </div>
                    <div className="tabRowTopRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_1`}
                      />
                    </div>
                    {/* middle rowss */}
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_2`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_2`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_3`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_3`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_4`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_4`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_5`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_5`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_6`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_6`}
                      />
                    </div>

                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_7`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_7`}
                      />
                    </div>

                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_8`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_8`}
                      />
                    </div>

                    {/* bottom row */}
                    <div className="tabRowBottomLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_2_9`}
                        />
                      </b>
                    </div>
                    <div className="tabRowBottomRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_2_9`}
                      />
                    </div>
                  </div>
                  <br />
                </span>
              </>
            );
          } else if (i === 3) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_3`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_3_1`} />
                </span>
                <br></br>
                <span>
                  <div className="tab3">
                    {/* table header */}
                    <div className="tabRowTopLeftHeader">
                      <Translate value={`legalPP_scope_text_3_1_header`} />
                    </div>
                    <div className="tabRowTopRightHeader">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_scope_text_3_2_header`}
                      />
                    </div>
                    {/* first row */}
                    <div className="tabRowTopLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_1`}
                        />
                      </b>
                    </div>
                    <div className="tabRowTopRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_1`}
                      />
                    </div>
                    {/* middle rowss */}
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_2`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_2`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_3`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_3`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_4`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_4`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_5`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_5`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_6`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_6`}
                      />
                    </div>
                    <div className="tabRowMiddleLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_7`}
                        />
                      </b>
                    </div>
                    <div className="tabRowMiddleRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_7`}
                      />
                    </div>
                    {/* bottom row */}
                    <div className="tabRowBottomLeft">
                      <b>
                        <Translate
                          className="tabletextpadding"
                          value={`legalPP_table_left_3_8`}
                        />
                      </b>
                    </div>
                    <div className="tabRowBottomRight">
                      <Translate
                        className="tabletextpadding"
                        value={`legalPP_table_right_3_8`}
                      />
                    </div>
                  </div>
                  <br />
                </span>
              </>
            );
          } else if (i === 4) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_4`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_4_1`} />
                  <Translate value={`legalPP_scope_text_4_2`} />
                </span>

                <br></br>
              </>
            );
          } else if (i === 5) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_5`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_5_1`} />
                  <Translate value={`legalPP_scope_text_5_2`} />
                </span>

                <br></br>
              </>
            );
          } else if (i === 6) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_6`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_6_1`} />
                </span>

                <br></br>
              </>
            );
          } else if (i === 7) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_7`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_7_1`} />
                </span>

                <br></br>
              </>
            );
          } else if (i === 8) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_8`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_8_1`} />
                </span>

                <br></br>
              </>
            );
          } else if (i === 9) {
            childrenListItems.push(
              <>
                <br></br>
                <b>
                  <Translate value={`legalPP_scope_text_9`} />
                </b>
                <br></br>
                <br></br>
                <span className="undertext">
                  <Translate value={`legalPP_scope_text_9_1`} />
                </span>

                <br></br>
              </>
            );
          }
        }
      } else {
        childrenListItems.push(
          <li>
            <Translate value={`${key}_point${i}`} />
          </li>
        );
      }
    }
    return <ol className="square">{childrenListItems}</ol>;
  }

  renderPrivacyPolicy() {
    return (
      <>
        <Translate className="pp-text" value="legalPP_scope_text" />
        {this.renderListItems("legalPP_scope_text", 9)}
      </>
    );
  }

  render() {
    return (
      <div id="privacy">
        {/* Header image */}
        <div className="evio-logo">
          <img src={SalvadorCaetanoLogo} alt="" />
        </div>
        <div className="pp-title">
          <Translate value="legalPP_privacy" />
        </div>
        {this.renderPrivacyPolicy()}
        <div className="footer">
          <br />
          <b>
            <Translate value="version_terms" /> 1.2
          </b>
          <div>22/05/2023</div>
        </div>
      </div>
    );
  }
}

export default Privacy;
